import _ from 'lodash';

export const extractProjectFromConsent = (consent: any) => {
  const consentMeta = _.get(consent, 'meta.tag', []);
  const projectMeta =
    consentMeta.find(
      (meta: any) => meta.system === 'http://lifeomic.com/fhir/dataset',
    ) || {};
  return projectMeta.code;
};

// Multiple consents can be returned including inactive, old consents.  Filter these out as they are not useful in this context
export const filterOutInactiveConsents = (consent: any) => {
  const status = _.get(consent, 'status');

  if (!status) {
    console.error('Unable to find status on returned consent');
  }

  return status !== 'inactive';
};

export const isConsentCompleted = (consent: any) => {
  return _.get(consent, 'status') === 'completed';
};

export function isConsentAccepted(
  questionnaireResponseItems: fhir.QuestionnaireResponse,
) {
  const responseItems = _.get(questionnaireResponseItems, 'item', []);
  const acceptanceItem = responseItems.find(
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    (item = {}) => item.linkId === 'acceptance',
  );
  return _.get(acceptanceItem, 'answer[0].valueBoolean', false);
}

export function questionnaireResponseToDirective(
  questionnaireResponse: any,
  projectId: any,
  isDefaultConsent: any,
) {
  const responseItems = _.get(questionnaireResponse, 'item', []);
  const consentAccepted = isConsentAccepted(questionnaireResponse);
  const directive = {
    projectId,
    status: consentAccepted ? 'active' : 'rejected',
  };

  const reponseItemsProp = isDefaultConsent ? 'consentForm' : 'response';
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  directive[reponseItemsProp] = { item: responseItems };

  return directive;
}

export function updateConsentFromResponse(
  consent = {},
  questionnaireResponse: any,
) {
  const consentAccepted = isConsentAccepted(questionnaireResponse);
  return {
    ...consent,
    status: consentAccepted ? 'active' : 'rejected',
  };
}

export const extractQuetionnaireRefsFromConsent = (consent: any) => {
  const consentMeta = _.get(consent, 'meta.tag', []);
  const questionnaireMeta =
    consentMeta.find(
      (meta: any) => meta.system === 'http://lifeomic.com/fhir/questionnaire',
    ) || {};
  const responseRef = _.get(consent, 'sourceReference.reference', '');

  return {
    questionnaire: questionnaireMeta.code,
    response: responseRef.replace('QuestionnaireResponse/', ''), // QuestionnaireResponse/<ID> -> <ID>
  };
};
